import './processPolyfill';
import './globals.css';
import './helpers/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setDocumentHeadLinks } from './helpers/setDocumentHeadLinks';
import App from './App';

setDocumentHeadLinks();

const container = document.getElementById('app');
const root = createRoot(container as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
